"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
function OffCanvas(_a) {
    var isOpen = _a.isOpen, children = _a.children, setIsOpen = _a.setIsOpen;
    var handleClose = function () {
        setIsOpen(false);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Drawer, __assign({ variant: "persistent", anchor: "right", open: isOpen, onClose: function () { return handleClose(); }, PaperProps: {
            sx: {
                width: {
                    xs: '100%',
                    sm: '54rem',
                },
                border: 'none',
                boxShadow: '0px 12px 50px rgba(80, 41, 239, 0.08)',
                backgroundColor: 'common.white',
            },
        } }, { children: children })));
}
exports.default = OffCanvas;
